/** Métricas con campo en `getClinicsComparison`. PVP y otras no soportadas no van acá. */
export const COMPARISON_METRIC_KEYS = [
  'cajaIngresos',
  'cajaNeto',
  'turnosTotal',
  'turnosAtendidos',
  'pacientesActivos',
  'pacientesNuevos',
  'attendanceRate',
  'turnosNoAsistio',
] as const;

export type ComparisonMetricKey = (typeof COMPARISON_METRIC_KEYS)[number];

/** Límite del wizard guiado (issue comparativa multi-clínica). */
export const MAX_COMPARISON_METRICS = 3;

export const DEFAULT_COMPARISON_METRIC_KEYS: ComparisonMetricKey[] = [
  'cajaIngresos',
  'turnosTotal',
  'turnosNoAsistio',
];

export const MAX_SAVED_COMPARISON_VIEWS = 5;

export interface SavedComparisonView {
  id: string;
  name: string;
  tenantIds: string[];
  metricKeys: ComparisonMetricKey[];
  createdAt: string;
}

const METRIC_SET = new Set<string>(COMPARISON_METRIC_KEYS);

export function isComparisonMetricKey(value: string): value is ComparisonMetricKey {
  return METRIC_SET.has(value);
}

export function sanitizeMetricKeys(values: string[]): ComparisonMetricKey[] {
  return [...new Set(values.filter(isComparisonMetricKey))].slice(0, MAX_COMPARISON_METRICS);
}

export function toggleComparisonMetric(
  current: ComparisonMetricKey[],
  key: ComparisonMetricKey,
  max = MAX_COMPARISON_METRICS
): ComparisonMetricKey[] {
  if (current.includes(key)) {
    return current.filter((item) => item !== key);
  }
  if (current.length >= max) {
    return current;
  }
  return [...current, key];
}

export function sanitizeTenantIds(values: string[], allowed: string[]): string[] {
  const allowedSet = new Set(allowed);
  return [...new Set(values.filter((id) => allowedSet.has(id)))];
}

export function canSaveComparisonView(input: {
  name: string;
  tenantIds: string[];
  metricKeys: string[];
  existingCount: number;
}): { ok: true } | { ok: false; reason: 'name' | 'clinics' | 'metrics' | 'limit' } {
  if (!input.name.trim()) {
    return { ok: false, reason: 'name' };
  }
  if (input.tenantIds.length < 2) {
    return { ok: false, reason: 'clinics' };
  }
  const metrics = sanitizeMetricKeys(input.metricKeys);
  if (metrics.length === 0) {
    return { ok: false, reason: 'metrics' };
  }
  if (input.existingCount >= MAX_SAVED_COMPARISON_VIEWS) {
    return { ok: false, reason: 'limit' };
  }
  return { ok: true };
}
